import Vue from 'vue';

Vue.filter('foreverTime', (date) => {
  if (!date) { return; }
  let time = date.split('-')[0];
  time && (time = parseInt(time));
  if (typeof date === 'string' && time >= 3000) {
    return '永久';
  } else {
    return date;
  }
});

Vue.filter('hideMobileNum', (mobile) => {
  return mobile && `${mobile.slice(0, 3)}****${mobile.slice(7)}`;
});
